/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetAgreementsResponse } from '../models/ApiResponseGetAgreementsResponse';
import type { CcspProfileEvent } from '../models/CcspProfileEvent';
import type { CreateAgreementsCommand } from '../models/CreateAgreementsCommand';
import type { DeleteAgreementsCommand } from '../models/DeleteAgreementsCommand';
import type { GetAgreementByVinResponse } from '../models/GetAgreementByVinResponse';
import type { HmgPrivacyUserEvent } from '../models/HmgPrivacyUserEvent';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AgreementsControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * UBI 서비스 해지
   * UBI 서비스 해지
   * @returns ApiResponseGetAgreementsResponse OK
   * @throws ApiError
   */
  public withdrawAgreements({
    requestBody,
  }: {
    requestBody: DeleteAgreementsCommand,
  }): CancelablePromise<ApiResponseGetAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agreements/withdraw',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 서비스 해지
   * UBI 서비스 해지
   * @returns ApiResponseGetAgreementsResponse OK
   * @throws ApiError
   */
  public withdrawAgreements1({
    requestBody,
  }: {
    requestBody: DeleteAgreementsCommand,
  }): CancelablePromise<ApiResponseGetAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agreements/withdraw/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 안전운전점수 초기화
   * 안전운전점수 초기화
   * @returns ApiResponseGetAgreementsResponse OK
   * @throws ApiError
   */
  public updateAgreements({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agreements/reset',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 초기화
   * 안전운전점수 초기화
   * @returns ApiResponseGetAgreementsResponse OK
   * @throws ApiError
   */
  public updateAgreements1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agreements/reset/',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * hmg-Privacy event subscribe
   * hmg-Privacy event subscribe
   * @returns any OK
   * @throws ApiError
   */
  public handlePrivacyCcsNewTermsEvent({
    requestBody,
  }: {
    requestBody: HmgPrivacyUserEvent,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agreements/hmg-privacy/event/ccs-new-terms/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * hmg-Privacy event subscribe
   * hmg-Privacy event subscribe
   * @returns any OK
   * @throws ApiError
   */
  public handlePrivacyCcsNewTermsEvent1({
    requestBody,
  }: {
    requestBody: HmgPrivacyUserEvent,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agreements/hmg-privacy/event/ccs-new-terms',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * ccsP profile event subscribe
   * ccsP profile event subscribe
   * @returns any OK
   * @throws ApiError
   */
  public handleProfileEvent({
    requestBody,
  }: {
    requestBody: CcspProfileEvent,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agreements/event',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * ccsP profile event subscribe
   * ccsP profile event subscribe
   * @returns any OK
   * @throws ApiError
   */
  public handleProfileEvent1({
    requestBody,
  }: {
    requestBody: CcspProfileEvent,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agreements/event/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 서비스 동의 조회
   * UBI 서비스 동의 조회
   * @returns ApiResponseGetAgreementsResponse OK
   * @throws ApiError
   */
  public getAgreementsByVinAndModel({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetAgreementsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/agreements',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * UBI 서비스 동의 저장
   * UBI 서비스 동의 저장
   * @returns ApiResponseGetAgreementsResponse OK
   * @throws ApiError
   */
  public createAgreements2({
    requestBody,
  }: {
    requestBody: CreateAgreementsCommand,
  }): CancelablePromise<ApiResponseGetAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agreements',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 서비스 동의 조회
   * UBI 서비스 동의 조회
   * @returns ApiResponseGetAgreementsResponse OK
   * @throws ApiError
   */
  public getAgreementsByVinAndModel1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetAgreementsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/agreements/',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * UBI 서비스 동의 저장
   * UBI 서비스 동의 저장
   * @returns ApiResponseGetAgreementsResponse OK
   * @throws ApiError
   */
  public createAgreements3({
    requestBody,
  }: {
    requestBody: CreateAgreementsCommand,
  }): CancelablePromise<ApiResponseGetAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agreements/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns GetAgreementByVinResponse OK
   * @throws ApiError
   */
  public getAgreementByVin({
    vin,
    model,
  }: {
    vin: string,
    model: string,
  }): CancelablePromise<GetAgreementByVinResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/agreements/cars/{vin}/models/{model}',
      path: {
        'vin': vin,
        'model': model,
      },
    });
  }
}
